<template>
    <div>
        <v-card class="white-card kimsa-elevation text-center pa-3">
            <v-row>
                <v-col cols="6">
                    <div class="stat-name">
                        {{ $t('entrance.weight') }}
                    </div>
                    <div class="stat-description">
                        {{ weight }} {{ $tc('common.kg', 1) }}
                    </div>
                </v-col>
                <v-col cols="6" class="border-left">
                    <div class="stat-name">
                        {{ $t('entrance.height') }}
                    </div>
                    <div class="stat-description">
                        {{ height }} {{ $tc('common.meters', 1) }}
                    </div>
                </v-col>
            </v-row>
            <v-btn v-if="!noEdit" color="primary" fab small depressed @click="edit" class="edit-btn">
                <v-icon color="black">$edit</v-icon>
            </v-btn>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        height: {
            type: String | Number,
            default: '-',
        },
        weight: {
            type: String | Number,
            default: '-',
        },
        noEdit: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        edit() {
            const vm = this
            vm.$router.push({name: 'student.profile.edit', params: {mode: 'SetWeight'}})
        },
    }
}
</script>

<style scoped>

.stat-name {
    color: #707070;
    font-size: 15px;
    line-height: 20px;
}

.stat-description {
    color: var(--v-accent-base);
    font-size: 17px;
    line-height: 22px;
    font-weight: bold;
}

.border-left {
    border-left: 1px solid #C5C5C5;
}

.edit-btn {
    position: absolute;
    top: -20px;
    right: -10px;
    border: 1px solid #333333 !important;
}

</style>